import { LineChart } from '@mui/x-charts/LineChart'
import { Paper, CircularProgress, Box } from '@mui/material'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { useGetVoucherChartQuery } from 'store/dashboard'
import ChartTitle from './ChartTitle'
import NoDataAvailable from './NoDataAvailable'
import { useTimeRange } from './TimeRangeContext'
import { lineChartBottomLegendSlotProps, chartSx } from './chartDefaults'

dayjs.extend(customParseFormat)

const VoucherChart = () => {
  const { startDate, endDate, tick } = useTimeRange()

  const { data, isLoading, isError, refetch, isFetching } = useGetVoucherChartQuery({
    startDate,
    endDate
  })

  const labelFormat = tick === 'month' ? 'MMM YYYY' : 'DD MMM YYYY'
  const chartData = data?.data?.map?.((d) => ({ ...d, label: dayjs(d.label, labelFormat) })) || []

  return (
    <Paper
      sx={{
        p: 2,
        height: '100%',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        boxShadow: 'none'
      }}
      elevation={0}
    >
      <ChartTitle tooltip='The distribution between issued vouchers and claimed vouchers'>
        Total Voucher vs Total Claim
      </ChartTitle>

      {isLoading || isFetching ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <CircularProgress />
        </Box>
      ) : isError ? (
        <NoDataAvailable variant='error' onRefresh={refetch} />
      ) : !data ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : data.data.length === 0 ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : (
        <>
          <Box sx={{ width: '100%', height: 300, mb: 3 }}>
            <LineChart
              xAxis={[
                {
                  scaleType: 'time',
                  data: chartData.map((x) => x.label.toDate()),
                  tickMinStep: tick === 'month' ? 1000 * 60 * 60 * 24 * 30 : 1000 * 60 * 60 * 24,
                  valueFormatter: (x) =>
                    dayjs(x).format(tick === 'month' ? 'MMM YYYY' : 'DD MMM YYYY')
                }
              ]}
              series={[
                {
                  label: 'Issued',
                  data: chartData.map((x) => x.issued),
                  color: '#002C5F'
                },
                {
                  label: 'Claimed',
                  data: chartData.map((x) => x.redeemed),
                  color: '#4A90D9'
                }
              ]}
              height={300}
              margin={{ top: 20, right: 30, left: 40, bottom: 60 }}
              slotProps={lineChartBottomLegendSlotProps}
              sx={chartSx}
            />
          </Box>
        </>
      )}
    </Paper>
  )
}

export default VoucherChart
